import { render, staticRenderFns } from "./UserBeaconHistory.vue?vue&type=template&id=3d8d24e8&"
import script from "./UserBeaconHistory.vue?vue&type=script&lang=js&"
export * from "./UserBeaconHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserBeaconHistory.vue?vue&type=style&index=0&id=3d8d24e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports